import "./Headings.scss";

export function SectionHeading({ children }: { children: React.ReactNode }) {
  return <div className="section-heading">{children}</div>;
}
